import { Component, OnInit, AfterViewInit, OnDestroy, Pipe, PipeTransform, ViewChild } from '@angular/core';
import { RestCallerService } from '../common/services/rest-caller.service';
import { AppComponent } from '../app.component';

declare var $: any;
declare var swal: any;
declare var moment: any;
declare var google: any;
declare var alasql: any;

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css'],
})

export class ReportsComponent implements OnInit, AfterViewInit {

  showLoader: boolean = false;
  reports: any = ['Select Report', 'Suspicious Pay Frequency', 'Clients Who Have Not Entered Payroll Information In The Selected Quarter', 'Client Contact Information'];
  quarters: any = [];
  reportData : any = [];
  selectedReport : string;
  selectedQuarter: string;
  activeReport: string;
  colNames: any = [];

  
  constructor(private restCallingService: RestCallerService) {

  }

  ngOnDestroy() {
    $('.nav>li.active').removeClass("active");
  }

  ngOnInit() {
    $('#reports').addClass('active');
  }

  ngAfterViewInit() {
    this.selectedReport = "Select Report";
    this.selectedQuarter = "Select Quarter";
  }

  ngOnChanges() {

  }

  resetData() {
    this.reportData = [];
    this.selectedReport = "Select Report";
    this.selectedQuarter = "Select Quarter";
  }

  getReport() {
    if (!this.selectedReport || this.selectedReport === 'Select Report') {
      swal("No Report Selected", "Must select a report." , "warning");
      return;
    }
    let json = this.createJson();
    if (!json) { 
      swal("Missing Parameters", "Must select all required parameters" , "warning");
      return;
    }
    this.showLoader = true;
    this.restCallingService.getReport(json).subscribe(data => {
      this.activeReport = this.selectedReport;
      this.showLoader = false;
      this.reportData = data.json();
      this.getColumnNames();
    }, err => {
      this.showLoader = false;
      swal('Failure!', "Error: " + err.json().message, 'error');
      console.log(err.json());
    });
  }

  getParameters() {
    if (this.selectedReport == 'Suspicious Pay Frequency') {
      this.quarters = [];
      this.quarters.push('Select Quarter');
      this.quarters.push('Current Quarter');
      this.quarters.push('Last Quarter')
      this.selectedQuarter = "Select Quarter";
    }
    if (this.selectedReport == 'Clients Who Have Not Entered Payroll Information In The Selected Quarter') {
      this.quarters = [];
      this.quarters.push('Select Quarter');
      this.quarters.push('Current Quarter');
      this.quarters.push('Last Quarter')
      this.selectedQuarter = "Select Quarter";
    }
  }

  getColumnNames() {
    this.colNames = [];
    for (let colName in this.reportData[0]) {
      this.colNames.push(colName);
    }
  }

  createJson() {
    let json: any = {};
    if (this.selectedReport == 'Suspicious Pay Frequency') {
      json['reportName'] = 'suspicious-payroll-pay-frequency';
      if (this.selectedQuarter == 'Current Quarter')
        json['quarterSelection'] = 'current';
      if (this.selectedQuarter == 'Last Quarter')
        json['quarterSelection'] = 'last';
      if (!this.selectedQuarter || this.selectedQuarter === 'Select Quarter')
        return null;
    }
    if (this.selectedReport == 'Clients Who Have Not Entered Payroll Information In The Selected Quarter') {
      json['reportName'] = 'clients-who-have-not-entered-info';
      if (this.selectedQuarter == 'Current Quarter')
        json['quarterSelection'] = 'current';
      if (this.selectedQuarter == 'Last Quarter')
        json['quarterSelection'] = 'last';
      if (!this.selectedQuarter || this.selectedQuarter === 'Select Quarter')
        return null;
    }
    if (this.selectedReport == 'Client Contact Information') {
      json['reportName'] = 'client-contact-info';
    }
    return json;
  }

  exportReport() {
    if (!this.reportData)
      return;
    let data: any = [];
    let columns: any = [];
    for (let colName of this.colNames) {
      columns.push(colName);
    }
    data.push(columns);
    for(let row of this.reportData) {
      let record: any = [];
      for (let col of this.colNames) {
        record.push(row[col] || '');
      }
      data.push(record);
    }
    alasql.promise('SELECT * INTO CSV(\"'+this.activeReport+'.CSV\", {headers:false, separator:","\}) FROM ?', [data])
      .then(function () {
        console.log('Data saved');
      }).catch(function (err) {
        console.log('Error:', err);
      });
  }
}


// WEBPACK FOOTER //
// ./src/app/reports/reports.component.ts